import Vue from 'vue';
import VueI18n from 'vue-i18n';
import Axios from 'axios';

Vue.use(VueI18n);

// Create VueI18n instance with options
const i18n = new VueI18n({
    locale: 'nb', // set locale
    silentTranslationWarn: true // do not warn about missing texts
});

const resourceObjects = [
    'Modellregister'
];

Axios.post('/api/Language/GetResourcesForObjects', resourceObjects)
    .then((response) => {
        i18n.setLocaleMessage('nb', response.data);
    });

export default i18n;